import { createContext, useContext } from 'react';

const PageStateContext = createContext({});

export function PageStateProvider({ children }) {
  const getState = (page) => {
    try { const v = localStorage.getItem('ps_' + page); return v ? JSON.parse(v) : null; } catch { return null; }
  };
  const setState = (page, data) => {
    try {
      // Храним только легкие данные — без data (статистика)
      // Для redistribution сохраняем данные полностью
      const toSave = page === 'redistribution' ? data : (() => { const { data: _data, ...light } = data; return light; })();
      localStorage.setItem('ps_' + page, JSON.stringify(toSave));
    } catch {}
  };
  const clearState = (page) => {
    try { localStorage.removeItem('ps_' + page); } catch {}
  };
  return (
    <PageStateContext.Provider value={{ getState, setState, clearState }}>
      {children}
    </PageStateContext.Provider>
  );
}

export const usePageState = (page) => {
  const { getState, setState, clearState } = useContext(PageStateContext);
  return {
    saved:      getState(page),
    save:  (d) => setState(page, d),
    clear: ()  => clearState(page),
  };
};
